define([
	"dojo/_base/declare",
	"./ReviewActual",
	"./ActualGapMixin"
], function(declare,ReviewActual,ActualGapMixin) {

	return declare([ActualGapMixin, ReviewActual], {
		highlightSetting: "sizeChartHighlightDeltaOutOfTolerance",

		_getActual: function(/*Context*/ctx) {
			// summary: return actual value
			return ctx.getNode().DimensionActuals[ctx.keyValue] || ctx.getNode().DimensionActuals[ctx.keyOriginalValue];
		},
		
		_getDiff: function(/*Number*/value, /*Number*/target) {
			// summary: return value since it is already the difference
			return value;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			return this._getValueGap(ctx);
		}
	});
});